import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '../../utils';
import { Calendar } from 'lucide-react';

export default function RecentLeaves({ leaves }) {
  return (
    <div className="bg-white rounded-lg border shadow-sm lg:col-span-2">
      <div className="p-6 pb-2">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">Pengajuan Cuti Terbaru</h3>
          <Link to={createPageUrl('LeaveList')}>
            <button className="text-sm text-gray-500 hover:text-gray-700">Lihat Semua</button>
          </Link>
        </div>
      </div>
      <div className="p-6 pt-0">
        {leaves.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <Calendar className="w-12 h-12 mx-auto mb-3 text-gray-300" />
            <p>Tidak ada pengajuan cuti</p>
          </div>
        ) : (
          <div className="space-y-3">
            {leaves.map(leave => (
              <div
                key={leave.id}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                    <Calendar className="w-5 h-5 text-amber-600" />
                  </div>
                  <div>
                    <p className="font-medium text-sm">
                      {leave.employee_name || leave.employee_id}
                    </p>
                    <p className="text-xs text-gray-500">
                      {leave.leave_type} • {leave.total_days} hari
                    </p>
                  </div>
                </div>
                <span className="px-2 py-1 bg-amber-100 text-amber-700 text-xs rounded-full font-medium">
                  Pending
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
